export interface Navurls {
	title: string;
	url: string;
	isContentSubLink: boolean;
	subLinks?: Navurls[];
}

export const WORDPRESS_LINKS: Navurls[] = [
	{ title: 'Inicio', url: 'https://www.crediautos.cl/', isContentSubLink: false },
	{
		title: 'Refinancia tu Crédito',
		url: 'https://www.crediautos.cl/refinancia-tu-credito/',
		isContentSubLink: false,
	},
	{
		title: 'Financiamiento',
		url: '/',
		isContentSubLink: true,
		subLinks: [
			{ title: 'Crédito Automotriz', url: '/', isContentSubLink: false },
			{ title: 'Crédito autos usados', url: '/', isContentSubLink: false },
			{
				title: 'Crédito Motos',
				url: 'https://www.crediautos.cl/credito-motos/',
				isContentSubLink: false,
			},
			{
				title: 'Auto finánciate',
				url: 'https://www.crediautos.cl/credito-prendario-autofinanciamiento/',
				isContentSubLink: false,
			},
		],
	},
	{
		title: 'TransfiereSeguro',
		url: 'https://www.crediautos.cl/transfiere-seguro/',
		isContentSubLink: false,
	},
	{
		title: 'Liquida tu Credito',
		url: '/credit-liquidation/',
		isContentSubLink: false,
	},
	{
		title: 'Simula tu crédito',
		url: 'https://www.crediautos.cl/simula-tu-credito/',
		isContentSubLink: false,
	},
	{ title: 'Novedades', url: 'https://www.crediautos.cl/noticias/', isContentSubLink: false },
	{ title: 'Contacto', url: 'https://www.crediautos.cl/contacto/', isContentSubLink: false },
];
